<div class="live" [style.display]="display" [style.marginTop.px]="marginTop">
  <blinker-svg width="6" height="6" [style.paddingRight.px]="paddingRight"></blinker-svg>LIVE&nbsp;&nbsp;
</div>